import {Base} from '../../common/model/base.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';

export class TipoEntitaLocale extends Base {

  constructor(protected id: number,
              public descr: string) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'descr'];
  }

  public getLabel() {
    return this.descr;
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    return new TableRow(this, rowValues);
  }
}
